import React, { createContext, ReactNode, useState } from 'react';
import { Content, User, CartInfo, PinInfo } from 'types/global';

type ContextProps = {
  controlStatus: boolean;
  navIndex: number;
  showModal: number;
  scale: number;
  content: Content;
  user: User;
  token: string;
  cart: Array<CartInfo>;
  priceArray: Array<CartInfo>;
  pinInfo: PinInfo;
  end: boolean;
  prepare: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<number>>;
  setControlStatus: React.Dispatch<React.SetStateAction<boolean>>;
  setNavIndex: React.Dispatch<React.SetStateAction<number>>;
  setScale: React.Dispatch<React.SetStateAction<number>>;
  setContent: React.Dispatch<React.SetStateAction<Content>>;
  setUser: React.Dispatch<React.SetStateAction<User>>;
  setToken: React.Dispatch<React.SetStateAction<string>>;
  setCart: React.Dispatch<React.SetStateAction<Array<CartInfo>>>;
  setPriceArray: React.Dispatch<React.SetStateAction<Array<CartInfo>>>;
  setPinInfo: React.Dispatch<React.SetStateAction<PinInfo>>;
  setEnd: React.Dispatch<React.SetStateAction<boolean>>;
  setPrepare: React.Dispatch<React.SetStateAction<boolean>>;
};

type Props = {
  children: ReactNode;
};

export const ControlContext = createContext<ContextProps>({
  controlStatus: true,
  navIndex: 0,
  showModal: 0,
  scale: 0,
  content: {
    index: -1,
    type: 0,
    url: '',
  },
  user: {
    firstname: '',
    lastname: '',
    phone: '',
    email: '',
  },
  end: false,
  token: '',
  cart: [],
  priceArray: [],
  pinInfo: {
    index: 0,
    pos: [0, 0, 0],
    partNumber: 1,
  },
  prepare: false,
  setShowModal: () => {},
  setControlStatus: () => {},
  setNavIndex: () => {},
  setScale: () => {},
  setContent: () => {},
  setUser: () => {},
  setToken: () => {},
  setCart: () => {},
  setPriceArray: () => {},
  setPinInfo: () => {},
  setEnd: () => {},
  setPrepare: () => {},
});

export const ControlProvider = ({ children }: Props) => {
  const [controlStatus, setControlStatus] = useState<boolean>(false);
  const [navIndex, setNavIndex] = useState<number>(0);
  const [showModal, setShowModal] = useState<number>(0);
  const [scale, setScale] = useState<number>(100);
  const [content, setContent] = useState<Content>({
    index: 0,
    type: 0,
    url: '',
  });
  const [token, setToken] = useState<string>('');
  const [user, setUser] = useState<User>({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
  });
  const [cart, setCart] = useState<Array<CartInfo>>([]);
  const [priceArray, setPriceArray] = useState<Array<CartInfo>>([]);
  const [pinInfo, setPinInfo] = useState<PinInfo>({
    index: 0,
    pos: [0, 0, 0],
    partNumber: 1,
  });
  const [end, setEnd] = useState<boolean>(false);
  const [prepare, setPrepare] = useState<boolean>(false);
  return (
    <ControlContext.Provider
      value={{
        controlStatus,
        navIndex,
        scale,
        content,
        user,
        token,
        showModal,
        cart,
        priceArray,
        pinInfo,
        prepare,
        end,
        setControlStatus,
        setNavIndex,
        setScale,
        setContent,
        setUser,
        setToken,
        setShowModal,
        setCart,
        setPriceArray,
        setPinInfo,
        setEnd,
        setPrepare,
      }}
    >
      {children}
    </ControlContext.Provider>
  );
};
